import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { Observable, Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  HttpClient,
  HttpHeaders,

  HttpEventType
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyInfo } from '../model/company.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { EmpInfo } from '../model/emp.model';
import { ProjectMemberInfo } from '../model/projectmember.model';

let today = new Date().toISOString()


@Component({
  selector: 'app-selectprojectassign-managersupport',
  templateUrl: './selectprojectassign-managersupport.component.html',
  styleUrls: ['./selectprojectassign-managersupport.component.css']
})
export class SelectprojectassignManagersupportComponent implements OnInit {

  ProjectManagementForm: FormGroup
  // ------------------------------- Assign Manager Zone -----------------------------------------------
  AssignPMForm: FormGroup
  AssignPMList: EmpInfo[] = [];
  cuurentselectProjectAssignPM: string = null

  // ------------------------------- Assign Manager Zone -----------------------------------------------

  subscriptionLoadProjectList: Subscription
  subscriptionCountProjectList: Subscription
  public body: string;

  ProjectPromise: Promise<ProjectInfo[]>
  ProjectList: ProjectInfo[] = [];
  ProjectStatusList: LookupInfo[] = [];
  CompanyList: CompanyInfo[] = [];
  projectInfo: ProjectInfo = new ProjectInfo;



  txtSearchProjectCode: string
  txtSearchProjectName: string
  isSearchSubmitted: boolean = false;
  txtProjectCode: string
  txtProjectName: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlCompany: string
  ddlAssignPM: string

  hidProjectId: number
  isOnUpdate: boolean;
  isSubmitted: any;
  pathImg: string;
  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  filesToUpload: File[] = [];
  RoleCode: string;

  resultUploadfile: any;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  //Pagination variable
  public currentPageNumber: number
  public ProjectTotal: number
  public totalPages: number
  public environment: number


  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;
  _UserName: string;
  _RoleCode: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService, private formBuilder: FormBuilder) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._UserName = this.activatedRoute.snapshot.params.UserName;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    GlobalService.CheckPagingAccessRights();
  }


  async ngOnInit() {

    // create control
    this.ProjectManagementForm = this.formBuilder.group({
      AssignPMForm: this.formBuilder.group({
        ddlAssignPM: ["", Validators.required],
      })
    });

    this.AssignPMForm = this.ProjectManagementForm.get('AssignPMForm') as FormGroup;

    //Initial pagination info
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;


    //Initial general data
    this._RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem("EmpRoleCode");
    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");
    this._UserName = !!this._UserName ? this._UserName : localStorage.getItem("UserName");


    this.resultUploadfile = { type: null };
    this.pathImg = "";

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProject(auth_token);
      this.OnLoadCountProjectList(auth_token);

      this.loadDDLStatus(auth_token)
      this.loadDDLCompany(auth_token)
    }

    this.txtSearchProjectCode = ""
    this.txtSearchProjectName = ""

    this.txtProjectCode = ""
    this.txtProjectName = ""
    this.txtProjectStart = ""
    this.txtProjectEnd = ""
    this.ddlProjectStatus = null
    this.ddlCompany = null
    this.ddlAssignPM = null

    //this.LoadMasterProjectList().then((data) => {
    //  this.ProjectList = data;
    //});
    //this.OnLoadCountProjectList(auth_token);
  }

  ///////////////////////////////////////Events////////////////////////////////////////////
  async btnClick_showProjectList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProject(auth_token);
    }

  }

  async btnClick_deleteProject(id) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{ProjectCode: " + id + "}";

      if (confirm("Are you sure you want to delete this Project?")) {
        this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/DeleteProjectList", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            async () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()
              var auth_token = await this.TokenService.RefreshToken();
              if (!!auth_token) {
                this.LoadProject(auth_token);
              }
            }
          )
      }
    }

  }

  async uploadImg() {
    if (this.filesToUpload != undefined) {
      if (this.filesToUpload.length > 0) {
        var tragetfile = this.filesToUpload[0];
        var filename = tragetfile.name;
        const formData = new FormData();
        formData.append("pathfile", "ClientApp/dist/assets/Image/ProjectLogo");
        formData.append('file', tragetfile, filename);

        this.resultUploadfile = await this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
          .toPromise();
      }
    }

  }



  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  async OnDeleteList_Click() {
    if (confirm("Are you sure you want to delete " + document.querySelectorAll('input[type="checkbox"]:checked').length + " Project?")) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var listDeleteChecked = $('[name="checkboxdelete"]:checked');
        let arrjson: ProjectInfo[] = [];

        //เก็บ List id ที่จะ delete
        $.each(listDeleteChecked, function (idx, val) {

          var curId = $(val).data('projectid');
          var model = new ProjectInfo;
          model.ProjectId = curId;
          arrjson.push(model);
        });

        //ส่งไป Delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Project/DeleteProjectCheckList", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {

              this.titlemodal = '';
              this.detailmodal = 'Position levels have been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              setTimeout(() => {
                //this.Loading(false, '');
                this.isSearchSubmitted = false;
                //Reload
                this.LoadMasterProjectList().then((data) => {
                  this.ProjectList = data;
                });
                this.OnLoadCountProjectList(auth_token);
              }, 500);


            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

              //setTimeout(() => { this.Loading(false, ''); }, 500);
            }
          });
      }
    }
  }

  //Name position clicked
  async OnAddRights_Click(projectid) {
    if (!!projectid) {
      //this.Loading(true, 'Loading...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadMasterProjectList(projectid).then((data) => {

          this.projectInfo = data[0];
          //this.MasterCode.setValue(data[0].PositionLevel);
          //this.MasterName.setValue(data[0].PositionLevelName);

          setTimeout(() => {
            //this.Loading(false, '');
            $('#modalCreateMasterTitle').html('Edit position level');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }

  //async btnClick_onDeleteProject() {

  //  if (confirm("Are you sure to delete these position?")) {

  //    var auth_token = await this.TokenService.RefreshToken();
  //    if (!!auth_token) {
  //      var listDeleteChecked = $('[name="checkboxdelete"]:checked');
  //      let arrjson: ProjectInfo[] = [];

  //      //เก็บ List id ที่จะ delete
  //      $.each(listDeleteChecked, function (idx, val) {

  //        var curId = $(val).data('projectid');
  //        var model = new ProjectInfo;
  //        model.ProjectId = curId;
  //        arrjson.push(model);
  //      });

  //      //ส่งไป Delete
  //      const httpOptions = {
  //        headers: new HttpHeaders({
  //          'Content-Type': 'application/json',
  //          'Authorization': `Bearer ${auth_token}`
  //        })
  //      };
  //      let strjson = JSON.stringify(arrjson);

  //      console.log(strjson);

  //      this.httpClient.post<any>(this.baseurl + "Project/DeleteProjectCheckList", strjson, httpOptions)
  //        .toPromise().then((data) => {
  //          if (!!data) {

  //            this.titlemodal = '';
  //            this.detailmodal = 'Position levels have been deleted successfully.';
  //            $('#ModalComplate .modal-header').text('Information');
  //            $('#ModalComplate .modal-header').addClass('bg-gold');
  //            $('#ModalComplate').modal();

  //          }
  //          else {

  //            this.titlemodal = 'Fail.';
  //            this.detailmodal = 'Delete fail.';
  //            $('#ModalError').modal();

  //            //setTimeout(() => { this.Loading(false, ''); }, 500);
  //          }
  //        });
  //    }
  //  }

  //  //let num = parseInt(this.hidcouchk);
  //  //for (var i = 0; i < num; i++) {
  //  //  var element = <HTMLInputElement>document.getElementById('chk' + i);
  //  //  var isChecked = element.checked;

  //  //  var element2 = <HTMLInputElement>document.getElementById('Id' + i);

  //  //  if (isChecked) {
  //  //    confirm("Are you sure you want to delete " + document.querySelectorAll('input[type="checkbox"]:checked').length + " Project?");
  //  //    await this.btnClick_deleteProject(parseInt(element2.value));
  //  //  }
  //  //}

  //  //var auth_token = await this.TokenService.RefreshToken();
  //  //if (!!auth_token) {
  //  //  this.LoadProject(auth_token);
  //  //}
  //}

  ///////////////////////////////////////Functions/////////////////////////////////////////



  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  LoadProject(auth_token) {
    this.subscriptionLoadProjectList = this.LoadProjectList(auth_token)
      .subscribe(
        data => {
          this.subscriptionLoadProjectList.unsubscribe();
          this.ProjectList = data;
          this.hidcouchk = this.ProjectList.length.toString();
          if (data.length == 0 && this.txtSearchProjectName == "" && this.txtSearchProjectCode == "" && this._RoleCode != "ADMIN") {
            if (!!this._ForK2 && this._ForK2 == 'Y') {
              if (!!this._EmpCode && !!this._UserName) {
                localStorage.setItem("EmpCode", this._EmpCode);
                localStorage.setItem("UserName", this._UserName);
                localStorage.setItem("EmpRoleCode", this._RoleCode);
              }
            }

            this.router.navigate(['project-detail'], { queryParams: { ProjectCode: data[0].ProjectCode } })

          }



        },
        err => {
          console.error('Observer got an error: ' + err)
        },
        () => {
          console.log('Observer got a complete notification')
        }

      )
  }

  async LoadMasterProjectList(dataId: number = 0): Promise<ProjectInfo[]> {
    var pathapi = "";
    var UserName = this._UserName;
    if (this._RoleCode == "MANAGER" || this._RoleCode == "ADMIN") {
      pathapi = "Project/GetProjectCriteria";
    } else {
      pathapi = "Project/GetProjectbyMemberCriteria";

    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      let data = {};
      data['ProjectId'] = dataId;
      data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
      data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
      data["EmpCode"] = this.checkUndefinedString(this._EmpCode);
      data["UserName"] = this.checkUndefinedString(UserName);
      data["rowFetch"] = environment.PageSize;
      data["rowOFFSet"] = offset;
      data["FlagDelete"] = "N";
      let strjson = JSON.stringify(data);

      return this.httpClient
        .post<ProjectInfo[]>(this.baseurl + pathapi,
          strjson, httpOptions).toPromise()
    }
  }

  LoadProjectList(auth_token): Observable<ProjectInfo[]> {
    var pathapi = "";
    var UserName = this._UserName;
    //if (this._RoleCode == "MANAGER" || this._RoleCode == "ADMIN" || this._RoleCode == "DIRECTOR") {
    //  pathapi = "Project/GetProjectCriteria";
    //} else {
    //  pathapi = "Project/GetProjectbyMemberCriteria";

    //}

    pathapi = "Project/GetProjectbyManager";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * environment.PageSize;

    let data = {};
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
    data["EmpCode"] = this.checkUndefinedString(this._EmpCode);
    data["UserName"] = this.checkUndefinedString(UserName);
    data["rowFetch"] = environment.PageSize;
    data["rowOFFSet"] = offset;
    data["FlagDelete"] = "N";
    data["ProjectStatusCode"] = "3"  // get status Completed only

    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<ProjectInfo[]>(this.baseurl + pathapi,
        strjson, httpOptions)

  }


  LoadCountProjectList(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    let data = {};
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
    data["EmpCode"] = this.checkUndefinedString(this._EmpCode);
    data["FlagDelete"] = "N";
    data["ProjectStatusCode"] = "3"  // get status Completed only

    data["FlagDelete"] = "N";
    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<number>(this.baseurl + "Project/GetCountProjectbyManager",
        strjson, httpOptions)
      .toPromise()
  }

  loadDDLStatus(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    let strjson = "{\"LookupType\":\"PROJECTSTATUS\" }";

    this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise().then((data) => {
        this.ProjectStatusList = data
      })
  }

  loadDDLCompany(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    let strjson = "{}";

    this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
      .toPromise().then((data) => {
        this.CompanyList = data
      })

  }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  clearInsertSection() {
    this.txtProjectCode = null
    this.txtProjectName = null
    this.txtProjectStart = null
    this.txtProjectEnd = null
    this.ddlProjectStatus = null
    this.ddlCompany = null

  }

  clearSearchSection() {

    this.txtSearchProjectCode = null
    this.txtSearchProjectName = null

  }

  btnClick_selectFile(traget) {
    var file = $(traget.currentTarget).parents().find(".file");
    file.trigger("click");
  }

  selectFileOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImg = reader.result as string;
    }
    // read the image file as a data URL.
    reader.readAsDataURL(ss.currentTarget.files[0]);
    $('#previewImg').show();
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  async OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadProject(auth_token);
      }
    }

  }

  OnLoadCountProjectList(auth_token) {
    //call function load count all ticket list on hand current role user
    this.LoadCountProjectList(auth_token).then(data => {
      this.ProjectTotal = data;
      if (this.ProjectTotal == 0) {
        this.currentPageNumber = 0;
      }
      this.totalPages = Math.ceil(this.ProjectTotal / environment.PageSize);
    });
  }

  // ------------------------------- Assign Manager Zone -----------------------------------------------
  async loadDDLAssignPM() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleCode'] = 'MANAGER';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.AssignPMList = data;
        });
    }
  }


  async btnAssignPMClick(ProjectCode, EmpAssignPM: string) {
    // reset form
    this.AssignPMForm.reset();
    //set current select project
    this.cuurentselectProjectAssignPM = ProjectCode;
    // load ddl AssignPM
    await this.loadDDLAssignPM();

    // set current Assign Manager
    this.AssignPMForm.patchValue({
      ddlAssignPM: EmpAssignPM,
    });

    // show modal Assign Manager
    $('#ModalAssignPM').modal();
  }

  async btnSubmitAssignPMClick() {
    if (this.AssignPMForm.valid) {
      // hide modal Assign Manager
      $('#ModalAssignPM').modal('hide');

      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var EmpAssignPM = this.AssignPMForm.get('ddlAssignPM').value;
        var EmpRoleAssignPM = $('#selectAssignPM option:selected').attr('emprolecode');

        var objectjson = {};
        objectjson['EmpCode'] = this.checkUndefinedString(EmpAssignPM.toString());
        objectjson['EmpRole'] = this.checkUndefinedString(EmpRoleAssignPM.toString());
        objectjson['ProjectCode'] = this.checkUndefinedString(this.cuurentselectProjectAssignPM);
        objectjson['ProjectType'] = 'Support';
        objectjson['PositionInProject'] = '1'; // from lookup MASTERPROJECTROLE 1 = Project Manager

        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/SaveAssignManagerProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
            this.titlemodal = 'Update Assign fail.';
            this.detailmodal = 'Action Assign Manager was update fail.';

            $('#ModalError').modal();

          },
            async () => {
              console.log("Update = " + this.isSubmitted)

              await this.LoadProject(auth_token);

              this.titlemodal = 'Submit Assign Manager succeed.';
              this.detailmodal = 'Update Assign Manager completed.';

              $('#ModalComplate').modal();

            }
          )

      }

    } else {
      //mark FormGroup Touched
      this.GlobalService.validateAllFormFields(this.AssignPMForm)

    }

  }
  // ------------------------------- Assign Manager Zone -----------------------------------------------


}


